import { cn } from '@/lib/utils'

export function ComingSoonBadge({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex items-center whitespace-nowrap rounded-full bg-neutral-200 px-2 py-0.5 text-[10px] font-semibold leading-none text-neutral-700',
        className,
      )}
    >
      coming soon!
    </span>
  )
}
